module.exports = __webpack_public_path__ + "img/ZF3588.967755f7.png";